import {
  getCicdHistoryRequest,
  getCicdHistoryLogRequest
} from '../../../api/api'
import {getUrl} from "../../../utils/global/geturl";  // 导入封装后的axios请求
import ajax from "../../../api/ajax";


const state = {
  data_type : "department",
  data_click_name: "",
  data_click_day : "",
  data_click_spec: "",
  start_time : "",
  end_time: ""
};

const getters = {
  getDataType(state){
    return state.data_type
  }
};

const actions = {
  async getCicdHistoryHandler ({commit}, params) {
    ajax.defaults.timeout = 2000; //这个接口响应时间较大改成1小时
    return getCicdHistoryRequest(getUrl(params)).then(response => response)
  },
  async getCicdHistoryLogHandler ({commit}, params) {
    ajax.defaults.timeout = 2000; //这个接口响应时间较大改成1小时
    return getCicdHistoryLogRequest(getUrl(params)).then(response => response)
  },
};

const mutations = {
    setDataType(state,t){
      state.data_type = t
    },
    setDataName(state,t){
      state.data_click_name = t
    },
    setDataDay(state,t){
      state.data_click_day = t
    },
    setDataSpec(state,t){
      state.data_click_spec = t
    },
    setStartTime(state,t){
      state.start_time = t;
    },
    setEndTime(state,t){
      state.end_time = t
    }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cicd/cicd.js